var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((_vm.list),function(ref,index){
var component = ref[0];
var show = ref[1];
return _c('div',{key:component.name},[(show())?_c('div',{staticClass:"announcement-wrapper"},[_c('i',{staticClass:"fa fa-close i-close",on:{"click":function($event){return _vm.list.splice(index, 1)}}}),_c(component,{tag:"component"})],1):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }